const _excluded = ["children"],
  _excluded2 = ["children"],
  _excluded3 = ["children"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { components } from "../select";
import { CountryFlagExpanded } from "../../countries";
export const CountryOption = props => {
  const {
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const country = props.data.label;
  const flagClass = props.data.value;
  return /*#__PURE__*/React.createElement(components.Option, rest, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement(CountryFlagExpanded, {
    alpha2: flagClass,
    className: "me-2 font-size-16 rounded"
  }), /*#__PURE__*/React.createElement("div", null, country)));
};
export const CountrySingleValue = props => {
  const {
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded2);
  const country = props.data.label;
  const flagClass = props.data.value;
  return /*#__PURE__*/React.createElement(components.SingleValue, rest, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement(CountryFlagExpanded, {
    alpha2: flagClass,
    className: "me-2 rounded"
  }), /*#__PURE__*/React.createElement("div", null, country)));
};
export const CountryMultiValueLabel = props => {
  const {
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded3);
  const country = props.data.label;
  const flagClass = props.data.value;
  return /*#__PURE__*/React.createElement(components.MultiValueLabel, rest, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement(CountryFlagExpanded, {
    alpha2: flagClass,
    className: "me-2 rounded"
  }), /*#__PURE__*/React.createElement("div", null, country)));
};